import Apiservice from '@/core/services/api.service';
import {API_URL} from '@/common/config.js'

const apiService = Apiservice;


export default class AcademicClassTeacherService {

    #api = null;

    constructor() {
        this.#api = `${API_URL}user/academic-class-teacher`;

    }

    all() {
        let url = `${this.#api}`;
        return apiService.get(url);
    }


    paginate(type = null) {
        let url = `${this.#api}`;
        if (type)
            url = url + '?type=' + type;
        return apiService.get(url);
    }

    update(id, data) {
        let url = `${this.#api}/${id}`
        return apiService.put(url, data);

    }
    create(data) {
        let url = `${this.#api}/create`
        return apiService.post(url, data);

    }
    store(data) {
        let url = `${this.#api}`
        return apiService.post(url, data);

    }

    show(id) {
        let url = `${this.#api}/${id}`
        return apiService.get(url);
    }
    getTeachersByCourseId(courseId) {
        // academic-class-teacher/{courseId}/teachers
        let url = `${this.#api}/${courseId}/teachers`
        return apiService.get(url);
    }

    delete(id) {
        let url = `${this.#api}/${id}`
        return apiService.delete(url);
    }
    getCoursesByUserId(userId) {
        let url = `${this.#api}/${userId}/courses`
        return apiService.get(url);
    }
}
